module.exports = __webpack_public_path__ + "img/05.28bcb1de.png";